var exports = {
  "k": "xe564cbfb--769c7c--container",
};

module.exports = exports;
